import { render } from "./upload.vue?vue&type=template&id=5132b2a8"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__